import { CdkDragDrop } from "@angular/cdk/drag-drop";
import { STEPPER_GLOBAL_OPTIONS } from "@angular/cdk/stepper";
import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatStepper } from "@angular/material/stepper";
import { Router } from "@angular/router";
import { DatatableConfig } from "src/app/config/DatatableConfig";
import {  IAsignatura, ICalificacionesBlackboard, IConfiguracionPonderacion, ICursosBlackboard, IGetAsignaturasResponse, IInstanciasResponse, IPeriodo } from "src/app/interfaces/integracion-blackboard";
import { IntegracionesBlackboardService } from "src/app/services/integraciones-blackboard/integraciones-blackboard.service";
import { IntegracionSharedService } from "../integracion-shared.service";

interface IParam {
  currPage: number;
  pageSize: number;
  search: string;
}

@Component({
  selector: "app-view-integracion-blackboard-crear",
  templateUrl: "./view-integracion-blackboard-crear.component.html",
  styleUrls: ["./view-integracion-blackboard-crear.component.scss"],
  providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { displayDefaultIndicatorType: false },
    },
  ],
})

export class ViewIntegracionBlackboardCrearComponent implements OnInit {
  dtOptions: DataTables.Settings = { ...DatatableConfig.blackboard_tabla };
  integracionForm: FormGroup = new FormGroup({
    siglaAsignatura: new FormControl("", Validators.required),
  });
  form2: FormGroup = new FormGroup({
    blackboard: new FormControl("1", Validators.required),
    idCurso: new FormControl("", Validators.required),
  });
  isSubmited = false;
  mostrarResultados = false;
  mostrarStepper = false;
  renderTableCursos = false;
  showConfirmLeave = false;

  filtroAsignaturas: IGetAsignaturasResponse = {} as IGetAsignaturasResponse;

  instancias: Array<IInstanciasResponse> = [];

  selectedIndex = 0;
  loadingSigla: boolean = false;

  listaCursos: Array<ICursosBlackboard> = [];

  //sigla asignatura
  siglaAsignaturaPaginacion = {
    pageSize: 20,
    currPage: 1,
    totalPages: 1,
    totalItems: 0,
  };
  tmpSigla: {
    SiglaPaginacion: {
      pageSize: number;
      currPage: number;
      totalPages: number;
      totalItems: number;
    };
    listado: {
      sigla: string;
      siglaIdSap: string;
      descripcion: string;
      idSap: string;
    }[];
  } = {
    SiglaPaginacion: {
      pageSize: 20,
      currPage: 1,
      totalPages: 1,
      totalItems: 0,
    },
    listado: [],
  };
  searchValueSigla: string = "";

  filtroSigla: string | undefined = undefined;

  //fin sigla asignatura

  periodos: Array<IPeriodo> = [];
  filtroPeriodos = [];

  //drag and drop

  pruebas = [];
  evaluaciones: {
    evaluacion: ICalificacionesBlackboard[];
  }[] = [];
  evaluacionesAsignadas: {
    evaluacion: ICalificacionesBlackboard[];
  }[] = [];
  listaCompletaEvaluaciones: {
    evaluacion: ICalificacionesBlackboard[];
  }[] = [];

  periodoSeleccionado: number = -1;

  deshabilitado = true;
  mostrarAlerta = false;
  nColumnas = 0;

  instanciaId = 0;
  codigoCursoBB = "";
  siglaCursoBB = "";
  nombreCursoBB = "";
  asignaturaId = 0;

  datosPonderacion: any = {};
  mostrarTooltipPerido = false;

  @ViewChild("stepper") private readonly stepper!: MatStepper;
  @ViewChild("listaContainers") listaContainers!: ElementRef;
  @ViewChild("titulosContainer") titulosContainer!: ElementRef;

  constructor(
    private readonly router: Router,
    private readonly _integracionService: IntegracionesBlackboardService,
    public readonly _integracionSharedService: IntegracionSharedService
  ) {}
  ngOnInit(): void {
    this.getInstancias();

    //drag and drop
    const childDiv = document.querySelector(".listaC");
    if (childDiv) {
      childDiv.addEventListener("wheel", (event) => {
        event.stopPropagation();
      });
    }
  }

  getInstancias() {
    this._integracionService.getInstancias().subscribe({
      next: (res: IInstanciasResponse[]) => {
        this.instancias = res;
      },
    });
  }

  getCursoBlackboard() {
    this.renderTableCursos = false;
    this.listaCursos = [];
    const asignaturaSigla = this.form2.get("idCurso")?.value;
    const instancia = this.form2.get("blackboard")?.value;
    this._integracionService
      .getBuscarCursoBlackboard(asignaturaSigla, instancia)
      .subscribe({
        next: (res: ICursosBlackboard) => {
          res["instancia"] = this.instancias.filter(
            (inst: IInstanciasResponse) => inst.id == instancia
          )[0].descripcion;
          this.instanciaId = instancia;
          this.codigoCursoBB = res.id;
          this.siglaCursoBB = res.cursoId;
          this.nombreCursoBB = res.nombre;
          this.listaCursos.push(res);
          this.renderTableCursos = true;
          document.getElementById("btn-siguiente")?.click();
        },
      });
  }
  //asignaturas

  onSearchSigla(term: {term: string, items:Array<IAsignatura>}): void {
    this.searchValueSigla = term.term;
    this.limpiarFiltros();

    if (term.term.length >= 3) {
      let reqParams: IParam = {
        currPage: 1,
        pageSize: 20,
        search: term.term.toUpperCase(),
      };

      this._integracionSharedService.getAsignaturas(this,reqParams);
    }
    if (
      (term.term.length > 3 || term.items.length === 0) &&
      this.filtroAsignaturas?.listado?.length <
        this.siglaAsignaturaPaginacion.totalItems
    ) {
      if (this.tmpSigla.listado.length === 0) {
        this.tmpSigla = {
          SiglaPaginacion: this.siglaAsignaturaPaginacion,
          listado: this.filtroAsignaturas.listado,
        };
      }
      // buscar en servicio
      let reqParams: IParam = {
        currPage: 1,
        pageSize: 20,
        search: term.term.toUpperCase(),
      };

      this._integracionSharedService.getAsignaturas(this,reqParams);
    }
  }
  changeSiglaAsignatura(evento: IAsignatura) {
    this.resetearVista();
    if (evento) {
      this.asignaturaId = evento.asignaturaId;
      this.integracionForm.get("siglaAsignatura")?.setValue(evento);
    }
  }

  //fin asignatura
  volverInicio() {
    this.router.navigate(["/integracion-blackboard"]);
  }
  abrirModal() {
    document.getElementById("modal-salir")?.click();
  }
  validarCampo() {
    return (
      typeof this.integracionForm.get("siglaAsignatura")?.value != "object"
    );
  }
  onSubmit() {
    this.isSubmited = true;
    if (this.form2.valid) {
      this.getCursoBlackboard();
    }
  }
  busqueda() {
    this.resetearVista();
    setTimeout(() => {
      if (this.integracionForm.valid) {
        let asignatura = this.integracionForm.get("siglaAsignatura")?.value;
        this.filtroAsignaturas.listado.forEach(
          (asign: { idSap: string; sigla: string }) => {
            if (asign.sigla === asignatura.sigla) {
              this.mostrarResultados = true;
            }
          }
        );
      }
    }, 100);
  }
  resetearVista() {
    this.mostrarResultados = false;
    this.mostrarStepper = false;
    this.selectedIndex = 0;
    this.siglaCursoBB = "";
    this.codigoCursoBB = "";
    this.evaluacionesAsignadas = [];
    this.evaluaciones = [];
    this.pruebas = [];
    this.periodoSeleccionado = -1;
  }
  limpiarFiltros() {
    this.filtroSigla = undefined;
    this.isSubmited = false;
    this.limpiarStep3();
    this.resetearVista();
    this.integracionForm.get("siglaAsignatura")?.setValue("");
    this.form2.get("idCurso")?.setValue("");
    const instanciaId = this.instancias.filter(
      (inst: IInstanciasResponse) => inst.preseleccionado === 1
    )[0].id;
    this.form2.get("blackboard")?.setValue(instanciaId);
    this.asignaturaId = 0;
  }

  //stepper
  onStepChange(event: any) {
    this.selectedIndex = event.selectedIndex;
  }
  //finStepper
  asignaturaSeleccionada(asignatura: IAsignatura) {
    this.mostrarStepper = true;
    this.form2.get("idCurso")?.setValue(asignatura.sigla);
    this.form2.get("blackboard")?.setValue(1);
    if (this.stepper) {
      this.mostrarStepper = false;
      this.selectedIndex = 0;
      setTimeout(() => {
        this.mostrarStepper = true;
      }, 10);
    }
  }
  avanzarStep3() {
    const arrowElement = document.querySelector(".mat-mdc-select-arrow");
    if (arrowElement) {
      arrowElement.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" class="select-icon" stroke="black" stroke-width="1.5" class="bi bi-chevron-down custom-icon" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"/>
</svg>`;
    }
    this._integracionService
      .getCalificacionesBlackboard(String(this.instanciaId), this.codigoCursoBB)
      .subscribe({
        next: (res: ICalificacionesBlackboard[]) => {
          if (res.length > 0) {
            res.forEach((evaluacion: ICalificacionesBlackboard) => {
              this.evaluaciones.push({ evaluacion: [evaluacion] });
            });
            this.rellenarListas();
          }

          document.getElementById("btn-siguiente2")?.click();
        },
      });
    this.getListaPeriodos(
      this.integracionForm.get("siglaAsignatura")?.value.sigla
    );
  }
  calcularPorcentaje(value: any): string {
    if (this.form2.get("idCurso")?.hasError("required") && this.isSubmited) {
      return "43%";
    } else {
      return value.length < 10 ? "84%" : "80%";
    }
  }

  //drag and drop
  get connectedDropLists() {
    let dropLists = this.evaluaciones.map((_, i) => `cdk-drop-list-${i}`);
    this.evaluacionesAsignadas.forEach((_, i) => {
      dropLists.push(`cdk-drop-list-${i + this.evaluaciones.length}`);
    });
    return dropLists;
  }

  drop(
    event: CdkDragDrop<
      { nombre: string; puntaje: number; id: string; categoria: string | null }[]
    >,
    listIndex: number,
    sort?: string
  ) {
    const previousListIndex = this.listaCompletaEvaluaciones.findIndex(
      (list) => list.evaluacion === event.previousContainer.data
    );
    const targetList = this.listaCompletaEvaluaciones[listIndex];
    const previousList = this.listaCompletaEvaluaciones[previousListIndex];

    if (previousList !== targetList) {
      // Intercambiar la evaluacion entre las listas si la lista objetivo ya tiene una evaluacion
      const targetEvaluacion = targetList.evaluacion[0]; // La evaluacion en la lista objetivo (si existe)
      const draggedEvaluacion = previousList.evaluacion[0]; // La evaluacion que se esta arrastrando

      // Mover la evaluacion arrastrada a la lista objetivo
      if (targetList.evaluacion.length > 0) {
        // Intercambiar evaluaciones: transferir la evaluacion de la lista objetivo de regreso a la lista anterior
        previousList.evaluacion = [targetEvaluacion];
      } else {
        // Si la lista objetivo estaba vacia, solo limpiar la lista anterior
        previousList.evaluacion = [];
      }

      // Establecer la evaluacion arrastrada en la lista objetivo
      targetList.evaluacion = [draggedEvaluacion];

      if (sort === "evaluacionesSort") {
        
        this.sortListas(this.evaluaciones);
        //ordenar lista completa pero solo hasta el largo de lista evaluaciones
        this.listaCompletaEvaluaciones = this.sortParcial(
          this.listaCompletaEvaluaciones,
          this.evaluaciones.length
        );

        
      }
    }
  }
  sortParcial(arreglo: Array<any>, index: number) {
    
    let sortedPart = this.sortListas(arreglo.slice(0, index));
    let unsortedPart = arreglo.slice(index);

    return [...sortedPart, ...unsortedPart];
  }
  sortListas(arreglo: Array<any>) {
    return arreglo.sort((a, b) => {
      if (a.evaluacion[0].nombre !== "" && b.evaluacion[0].nombre === "")
        return -1;
      if (a.evaluacion[0].nombre === "" && b.evaluacion[0].nombre !== "")
        return 1;
      return 0;
    });
  }
  mostrarMensajeConfirmacion() {
    this.nColumnas = 0;
    this.evaluacionesAsignadas.forEach((eva: any) => {
      if (eva.evaluacion[0].nombre === "") {
        this.nColumnas++;
      }
    });

    document.getElementById("modal-confirmar")?.click();
  }
  crearIntegracion() {
    const listaAlineaciones = this.evaluacionesAsignadas
      .map((eva, index) => {
        if (eva.evaluacion[0].nombre === "") return null;
        return {
          detPonderacionId:
            this.datosPonderacion.calificaciones[index].detPonderacionId,
          bbColumnaId: eva.evaluacion[0].id,
          nombreAsignaturaBb: eva.evaluacion[0].nombre,
        };
      })
      .filter((evaluacion: any) => evaluacion !== null);

    let periodoSeleccionado = this.periodos[this.periodoSeleccionado];
    let body = {
      instanciaBbId: this.instanciaId,
      bbId: this.codigoCursoBB,
      bbCursoId: this.siglaCursoBB,
      anoAcademico: periodoSeleccionado.anoAcademico,
      periodoAcademicoId: periodoSeleccionado.periodoAcademicoId,
      asignaturaId: this.asignaturaId,
      codigoAsignatura:
        this.integracionForm.get("siglaAsignatura")?.value.sigla,
      alineaciones: listaAlineaciones,
    };
    if(body.alineaciones.length !== 0) {
      this._integracionService.postCrearAlineacion(body).subscribe({
        next: () => {
          this.router.navigate(["/integracion-blackboard"], {
            state: { data: { integracionCreada: true } },
          });
        },
        error: () => {
          this.router.navigate(["/integracion-blackboard"], {
            state: { data: { integracionError: true } },
          });
        },
      });
    }
  }
  getListaPeriodos(siglaAsignaturaPDC: string) {
    this._integracionService.getListaPeriodos(siglaAsignaturaPDC).subscribe({
      next: (res:IPeriodo[]) => {
        this.periodos = res;
      },
    });
  }
  buscarPonderacion() {
    this.pruebas = [];
    this.evaluacionesAsignadas = [];
    let periodoSeleccionado = this.periodos[this.periodoSeleccionado];
    this._integracionService
      .getConfiguracion(
        periodoSeleccionado.anoAcademico,
        periodoSeleccionado.periodoAcademicoId,
        String(this.asignaturaId)
      )
      .subscribe({
        next: (res: IConfiguracionPonderacion) => {
          if (res.error) {
            this.mostrarAlerta = true;
          } else {
            let calificaciones: Array<any> = [];
            res.notasParciales.forEach(({ tipo, ...nota }: any) =>
              calificaciones.push({ tipo: "CP", ...nota })
            );

            res.examenes.forEach(({ tipo, ...nota }: any) =>
              calificaciones.push({ tipo: "CE", ...nota })
            );
            
            this.datosPonderacion = {
              calificaciones: calificaciones,
              ponderacionId: res.ponderacionBaseId,
              valor: res.valor,
            };
            this.pruebas = this.datosPonderacion.calificaciones.map(
              ({ tipo, nroNota, porcentaje }: any) =>
                `${tipo}${nroNota} (${porcentaje}%)`
            );

            this.rellenarListas();
            this.deshabilitado = false;
          }
        },
      });
  }
  rellenarListas() {
    this.listaCompletaEvaluaciones = [];

    this.evaluaciones.forEach((evaluacion) =>
      this.listaCompletaEvaluaciones.push(evaluacion)
    );

    this.evaluacionesAsignadas = this.pruebas.map(() => ({
      evaluacion: [{ nombre: "", puntaje: 0, categoria: "", id: "" }],
    }));
    this.evaluacionesAsignadas.forEach((evaluacion) =>
      this.listaCompletaEvaluaciones.push(evaluacion)
    );
  }

  resetearDragAndDrop() {
    this.pruebas = [];
    this.evaluacionesAsignadas = [];
    this.deshabilitado = true;
    this.mostrarAlerta = false;
  }
  limpiarStep3() {
    this.resetearDragAndDrop();
    this.evaluaciones = [];
    this.periodoSeleccionado = -1;
  }
  redirigirPonderar() {
    this.router.navigate(['/ponderacion-individual-inicio'])
  }
  deshabilitarBtnCrear() {
    return this.evaluacionesAsignadas.filter((evaluacion)=> evaluacion.evaluacion[0].nombre !== '').length === 0
  }
}
